import React, { useEffect, useState } from 'react';
import { API } from '../api/client';
import { App } from './App';

type Session = { authenticated: boolean; user: string | null; auth_enabled: boolean };

export function LoginGate() {
  const [session, setSession] = useState<Session | null>(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function refresh() {
    const response = await fetch(`${API}/auth/session`, { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('Não foi possível verificar a sessão.');
    setSession(await response.json());
  }

  useEffect(() => {
    refresh().catch((e) => setError(e.message));
  }, []);

  async function login(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setBusy(true);
    setError('');
    const form = new FormData(event.currentTarget);
    try {
      const response = await fetch(`${API}/auth/login`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: String(form.get('username') || ''), password: String(form.get('password') || '') }),
      });
      await response.json().catch(() => ({}));
      if (!response.ok) throw new Error('Usuário ou senha inválidos.');
      await refresh();
    } catch (e: any) {
      setError(e.message || 'Falha no login.');
    } finally {
      setBusy(false);
    }
  }

  async function logout() {
    await fetch(`${API}/auth/logout`, { method: 'POST', credentials: 'same-origin' });
    await refresh();
  }

  if (!session) return <main className="loading-page">{error || 'Verificando acesso...'}</main>;
  if (!session.auth_enabled || session.authenticated) {
    return (
      <>
        <App />
        {session.auth_enabled && (
          <button
            type="button"
            onClick={logout}
            style={{ position: 'fixed', right: 16, bottom: 16, zIndex: 1000, padding: '8px 12px', borderRadius: 8 }}
          >
            Sair · {session.user}
          </button>
        )}
      </>
    );
  }

  return (
    <main className="login-page">
      <section className="login-card" aria-labelledby="login-title">
        <img className="login-logo" src="/logomarca.png" alt="ZURC" />
        <header className="login-heading">
          <h1 id="login-title">PropostaZURC</h1>
          <p>Entre com o usuário e a senha internos fornecidos pela ZURC.</p>
        </header>
        <form className="login-form" onSubmit={login}>
          <div className="login-field">
            <label htmlFor="username">Usuário</label>
            <input id="username" name="username" autoComplete="username" required autoFocus />
          </div>
          <div className="login-field">
            <label htmlFor="password">Senha</label>
            <input id="password" name="password" type="password" autoComplete="current-password" required />
          </div>
          {error && <p className="login-error" role="alert" aria-live="polite">{error}</p>}
          <button className="login-submit" type="submit" disabled={busy}>{busy ? 'Entrando...' : 'Entrar'}</button>
        </form>
        <footer className="login-footer">PropostaZURC · Beta</footer>
      </section>
    </main>
  );
}
